// src/app/sse.service.ts
import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@dal/core';
import { OktaAuthService } from '@dal/core';
import { EventSourcePolyfill } from 'event-source-polyfill';

@Injectable({
  providedIn: 'root'
})
export class SseService {
  private baseUrl: string = environment.apiBaseUrl;
  private eventSource!: EventSourcePolyfill;
  private retryDelay = 1000;
  private maxRetryDelay = 30000;

  constructor(private zone: NgZone, private authService: OktaAuthService) { }

  connectToJobsStream(): Observable<any> {
    return new Observable(observer => {
      const accessToken = this.authService.getToken();
      const url = `${this.baseUrl}/jobs/stream/all`;
      // const url =`http://localhost:8080/events`;
      this.eventSource = new EventSourcePolyfill(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        heartbeatTimeout: 60000, // Example: 10 seconds
      });

      this.eventSource.onopen = () => {
        console.log('SSE connection established');
      };
      
      this.eventSource.onmessage = (event: MessageEvent) => {
        if (!event.data || event.data.trim() === "") {
          console.warn("Received empty message from server");
          return;
        }
  
        this.zone.run(() => {
            observer.next(JSON.parse(event.data));
        });
      };

      this.eventSource.onerror = (error: any) => {
        this.zone.run(() => {
          console.warn('SSE connection error — will attempt to reconnect', error);
          // No observer.error()
          // No eventSource.close()
          this.reconnect();
        });
      };

      return () => {
        this.eventSource.close();
      };
    });
  }

  private reconnect() {
    this.disconnect();
    this.retryDelay = Math.min(this.retryDelay * 2, this.maxRetryDelay);
    
    setTimeout(() => {
      // Implement your reconnection logic here
      console.log(`Reconnecting in ${this.retryDelay}ms...`);
      this.connectToJobsStream();
    }, this.retryDelay);
  }

  disconnect() {
    if (this.eventSource) {
      this.eventSource.close();
      this.retryDelay = 1000;
    }
  }
}
